export default __webpack_public_path__ + "static/media/play.d49662d7.svg";